import script from "./BackgroundGallery.vue?vue&type=script&setup=true&lang=ts"
export * from "./BackgroundGallery.vue?vue&type=script&setup=true&lang=ts"

import "./BackgroundGallery.vue?vue&type=style&index=0&id=68d8b9f0&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-68d8b9f0"]])

export default __exports__